import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSend, FiCheckCircle, FiChevronRight } = FiIcons;

export default function InquiryForm() {
  const [status, setStatus] = useState('idle'); // idle, sending, success

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');
    // Simulate inquiry submission to anton@listen.ph (email is hidden in logic)
    setTimeout(() => setStatus('success'), 1500);
  };

  return (
    <section id="inquiry" className="py-32 bg-black relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-sm font-black text-indigo-500 uppercase tracking-[0.4em] mb-4">Partner with Us</h2>
          <h3 className="text-4xl md:text-6xl font-black tracking-tighter mb-6 text-white leading-tight">
            Request a <span className="text-slate-500 italic">System Test.</span>
          </h3>
          <p className="text-slate-400 text-lg md:text-xl font-light max-w-2xl mx-auto">
            Experience the frictionless gallery. Send an inquiry and our team will set up a private demo for your next event.
          </p>
        </div>

        <div className="glass-card rounded-[2.5rem] p-8 md:p-12 border border-white/5 shadow-2xl">
          <AnimatePresence mode="wait">
            {status === 'success' ? (
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="text-center py-12"
              >
                <div className="w-20 h-20 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={FiCheckCircle} className="text-4xl text-green-500" />
                </div>
                <h4 className="text-2xl font-bold text-white mb-2">Inquiry Received</h4>
                <p className="text-slate-400">Our team will reach out within 24 hours to schedule your demo.</p>
              </motion.div>
            ) : (
              <motion.form
                exit={{ opacity: 0, y: -20 }}
                onSubmit={handleSubmit}
                className="space-y-6"
              >
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-xs font-black uppercase tracking-widest text-slate-500 ml-1">Your Name</label>
                    <input required type="text" placeholder="John Doe" className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-indigo-500 transition-colors" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-black uppercase tracking-widest text-slate-500 ml-1">Work Email</label>
                    <input required type="email" placeholder="john@company.com" className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-indigo-500 transition-colors" />
                  </div>
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-black uppercase tracking-widest text-slate-500 ml-1">Event Type & Date</label>
                  <input required type="text" placeholder="e.g. Luxury Wedding, June 2026" className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-indigo-500 transition-colors" />
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-black uppercase tracking-widest text-slate-500 ml-1">Message</label>
                  <textarea required rows="4" placeholder="Tell us about your event goals..." className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-indigo-500 transition-colors resize-none"></textarea>
                </div>
                <button
                  disabled={status === 'sending'}
                  className="w-full bg-white text-black py-5 rounded-2xl text-lg font-black hover:bg-indigo-500 hover:text-white transition-all flex items-center justify-center gap-3 disabled:opacity-50"
                >
                  {status === 'sending' ? 'Sending...' : (
                    <>
                      Send Inquiry <SafeIcon icon={FiSend} />
                    </>
                  )}
                </button>
              </motion.form>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}